import Button from '@mui/material/Button';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import { UpdateDialog } from '../UpdateDialog';

export function UploadSection() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)} startIcon={<UploadFileIcon />}>
        <FormattedMessage id="upload.button.button_update" defaultMessage="Update data" />
      </Button>

      <UpdateDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
